import { decode } from 'he';

/**
 * A post's words as readers see them: feed text arrives with HTML entities
 * ("[&#8230;]" → "[…]"), and rows made from a feed can hold its HTML (backlog
 * 56463e51: "<figure><img srcset=…>"). Keep this rule identical to smagent-apiserver
 * reach/services/postWords.js, which also goes for what the networks are sent.
 */

const NO_WORDS = /<!--[\s\S]*?-->|<(figure|script|style|noscript)\b[\s\S]*?<\/\1\s*>/gi;
const TAG = /<\/?[a-z][a-z0-9-]*(?:\s(?:"[^"]*"|'[^']*'|[^'">])*)?\/?>/gi;
const LOOSE_TAG = /<\/?[a-z][a-z0-9-]*(?:\s[^<>]*)?>/gi;
const CUT_TAG = /<\/?[a-z][a-z0-9-]*\s[^<>]*=[^<>]*$/i;
const MARKUP = /<!--|<\/?[a-z][a-z0-9-]*(?:\s[^<>]*)?>|<\/?[a-z][a-z0-9-]*\s[^<>]*=[^<>]*$/i;
const TRUNCATION_MARK = /\s*\[\s*(?:…|\.{3})\s*\]\s*$/;

function fullyDecode(text: string) {
  let out = text;
  for (let i = 0; i < 3; i++) {
    const next = decode(out);
    if (next === out) break;
    out = next;
  }
  return out;
}

function captionText(raw: string) {
  let text = fullyDecode(raw)
    .replace(NO_WORDS, ' ')
    .replace(TAG, ' ')
    .replace(LOOSE_TAG, ' ')
    .replace(CUT_TAG, ' ');
  text = text.replace(/\s+/g, ' ').trim();
  if (TRUNCATION_MARK.test(text)) {
    text = text.replace(TRUNCATION_MARK, '').trim();
    if (text && !/[.!?…]$/.test(text)) text += '…';
  }
  return text;
}

// Who chose these exact words: "use the <img> tag" is what they meant to say.
const CHOSEN_WORDS = new Set(['user', 'mcp', 'api']);

export function postWords(p: {
  summary?: string | null;
  title?: string | null;
  createdVia?: string | null;
}) {
  const words = (raw?: string | null) => {
    const text = raw || '';
    return !CHOSEN_WORDS.has(p.createdVia || '') && MARKUP.test(fullyDecode(text))
      ? captionText(text)
      : decode(text).trim();
  };
  return words(p.summary) || words(p.title);
}
